'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import OffcanvasContent from '@/src/app/components/OffCanvasNavigation/OffcanvasContent/OffcanvasContent';
import { NavigationNode, NavigationRestAttributes } from '@/src/lib/navigation/type';
import { DeserializedStore } from '@/src/lib/store/types';
import { Dictionary } from '@/src/lib/dictionary/types';
import { DeserializedObject } from '@/src/lib/http/jsonapi/deserializer';
import { eventBus } from '@/src/lib/core/event/bus';
import { EventBusName } from '@/src/lib/core/event/types';
import OffCanvas from '@/src/app/components/OffCanvas/OffCanvas';
import OffcanvasToggleButton from '@/src/app/components/OffCanvasNavigation/OffcanvasToggle/OffcanvasToggleButton';
export type OffcanvasNavigations = {
  primaryNavigation: DeserializedObject<NavigationRestAttributes> | undefined;
  secondaryNavigation: DeserializedObject<NavigationRestAttributes> | undefined;
  tertiaryNavigation: DeserializedObject<NavigationRestAttributes> | undefined;
};
type OffcanvasToggleProps = {
  dict: Dictionary;
  lang: string;
  country: string;
  navigations?: OffcanvasNavigations;
  getDictionary: (lang: string) => Promise<Dictionary>;
  store?: DeserializedStore;
} & React.JSX.IntrinsicElements['button'];
function OffcanvasToggle(t0) {
  const $ = _c(23);
  const {
    dict,
    lang,
    country,
    getDictionary,
    navigations,
    store
  } = t0;
  const [open, setOpen] = useState(false);
  const [targetNavigationNode, setTargetNavigationNode] = useState(undefined);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const listener = navigationNode => {
        setTargetNavigationNode(navigationNode);
        setOpen(true);
      };
      document.body.classList.add("offcanvas-ready");
      eventBus.on(EventBusName.HEADER_NAVIGATION_CLICK_OPEN_OFFCANVAS, listener);
      return () => {
        eventBus.off(EventBusName.HEADER_NAVIGATION_CLICK_OPEN_OFFCANVAS, listener);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== open) {
    t3 = function onToggle() {
      setOpen(!open);
      setTargetNavigationNode(undefined);
    };
    $[2] = open;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onToggle = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setOpen(false);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(false);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== country || $[7] !== dict || $[8] !== getDictionary || $[9] !== lang || $[10] !== navigations || $[11] !== store || $[12] !== targetNavigationNode) {
    t6 = <OffcanvasContent onCloseClick={t5} dict={dict} lang={lang} country={country} navigations={navigations} getDictionary={getDictionary} store={store} targetNavigationNode={targetNavigationNode} />;
    $[6] = country;
    $[7] = dict;
    $[8] = getDictionary;
    $[9] = lang;
    $[10] = navigations;
    $[11] = store;
    $[12] = targetNavigationNode;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== open || $[15] !== t6) {
    t7 = <OffCanvas isOpen={open} handleClose={t4}>{t6}</OffCanvas>;
    $[14] = open;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onToggle || $[18] !== open) {
    t8 = <OffcanvasToggleButton onToggle={onToggle} open={open} />;
    $[17] = onToggle;
    $[18] = open;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
export default OffcanvasToggle;